import React, { useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType, Navigation, Autoplay } from 'swiper';

import { GalleryImg } from '../constants/community-constants';
import { Link } from 'react-router-dom';
import { getLastInvestments } from '../../../services/ownerServices';
import { dateToRelativeFormat, numberToCurrencyFormat } from '../../../utils';
/* import iconPlay2 from "../../../assets/img/projects/play-transparente2.svg"; */
import iconPlay from "../../../assets/img/projects/play-transparente.svg";

export const CommunityGallery = () => {
  const [playingIndex, setPlayingIndex] = useState<number | null>(null);
  const [showVideo, setShowVideo] = useState(['']);

  const handleVideoPlay = (index: number) => {
    if (playingIndex !== null && playingIndex !== index) {
      const currentVideo = document.getElementById(`video-${playingIndex}`) as HTMLVideoElement;
      if (currentVideo) {
        currentVideo.pause();
      }
    }
    setPlayingIndex(index);
  };

  const playVideo = (index: number) => {
    if (!showVideo.includes(`video-${index}`)) {
      setShowVideo(prevOptions => [...prevOptions, `video-${index}`]);
      setTimeout(() => {
        const currentVideo = document.getElementById(`video-${index}`) as HTMLVideoElement;
        if (currentVideo) {
          currentVideo.play();
        }
      }, 0);
    }
  };

  const mainVideoIndex = 2;

  

  const filteredImagesWithTestimonies = GalleryImg.filter((item) => item.img).slice(0 ,  4);

  return (
    <div>
      <div className="grid grid-cols-12 mb-4 gap-3">
        
      <div className="w-full aspect-square col-span-12 md:col-span-6 row-span-2 rounded-3xl overflow-hidden relative">


  {GalleryImg[mainVideoIndex].video ? (
    showVideo.includes(`video-${mainVideoIndex}`) ? (
      <div className="w-full h-full bg-black">
        <video
          id={`video-${mainVideoIndex}`}
          controls
          controlsList="nodownload nofullscreen"
          className="w-full h-full object-cover"
          preload="none"
          onPlay={() => handleVideoPlay(mainVideoIndex)}
        >
          <source src={GalleryImg[mainVideoIndex].video} type="video/mp4" />
          Tu navegador no soporta el elemento de video.
        </video>
      </div>
    ) : (
      <div
        className="w-full aspect-square md:h-full cursor-pointer flex items-center justify-center relative"
        onClick={() => playVideo(mainVideoIndex)}
      >
        <img src={GalleryImg[mainVideoIndex].img} alt="Main video thumbnail" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#6DECB9] opacity-40"></div>
        <div className="absolute bottom-4 right-4">
          <img src={iconPlay} alt="Play icon" className="h-20 w-20 hover:scale-110 transition-transform" />
        </div>
      </div>
    )
  ) : (
    <div className="w-full h-[300px] md:h-full flex items-center justify-center">
      <img src={GalleryImg[mainVideoIndex].img} alt="Main video thumbnail" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#6DECB9] opacity-40"></div>
    </div>
  )}
</div>

{filteredImagesWithTestimonies.map((item, index) => {

  return (
    <div
      key={item.img || index}
      className="col-span-6 md:col-span-3 rounded-3xl overflow-hidden relative group"
            >
              {item.img && item.testimony? (
                <div className="relative w-full h-full group">
                  <div className="w-full h-full peer">
                    <img
                      src={item.img}
                      alt={`TESTIMONIO INVERSIONISTA ${index} LOKL S A S`}
                      
                      className="w-full h-full object-cover transition-all duration-300"
                    />
                  </div>
                  <div className="opacity-[0] hover:opacity-[1] absolute top-0 left-0 w-full h-full bg-black/50 px-6 py-10 transition duration-300">
                    {item.testimony && (
                      <p className="text-white lg:text-lg text-sm text-center">
                        {item.testimony}
                      </p>
                    )}
                  </div>
                </div>
              ) : (
                
                <div className="relative w-full h-full bg-black flex items-center justify-center">
                  <img
                    src="https://lokl-assets.s3.us-east-1.amazonaws.com/lokl/img-lokl-green.png"
                    alt={`TESTIMONIO INVERSIONISTA 1 LOKL S A S`}
                    className="w-[50%] h-auto object-contain"
                  />
                </div>
              )}
            </div>
          );
        })}

      </div>

      <a 
        id="CuentanosComunidad"
        href="https://api.whatsapp.com/send/?phone=573126715883&text=Hola%21%20me%20gustar%C3%ADa%20contar%20mi%20experiencia%20en%20LOKL"
        target="blank"
       className="block w-full max-w-[900px] text-[#3533FF] text-xl md:text-2xl font-semibold primaryFont underline leading-snug md:leading-normal"
      >
        Ya haces parte de la comunidad? Cuentanos sobre tu experiencia AQUI
      </a>
    </div>
  );
};


export const Community = ({ investors }: { investors: string }) => {
  const swiperRef = useRef<SwiperType>();

  const [lastInvestments, setLastInvestments] = useState<any>([]);

  useEffect(() => {
    getLastInvestments().then((response) => {
      setLastInvestments(response.data.data)
    })
  }, []);

  return (
    <div>

      <div className="flex gap-0 md:gap-0 md:items-end mb-10 flex-col md:flex-row">
      <h2 className="w-[470px] h-[63px] text-[#3533FF] text-[20px]  md:text-[40px] font-bold primaryFont leading-[35px]">NUESTRA COMUNIDAD</h2>
        <div className='mb-14 w-[200px] h-[26px]'>
          <p className="text-black/80 text-base font-normal secondaryFont"> Ya somos <span className="text-[#000000] numberFont text-3xl font-bold">+{investors}</span></p>
          <p className="text-black/80  text-base font-normal secondaryFont"> inversionistas creciendo juntos </p>
        </div>
      </div>

      <div className="md:grid-cols-12 md:gap-10 hidden md:grid">
        
        <div className="col-span-9 relative px-2 py-6">
        <Swiper
            breakpoints={{
              640: {
                slidesPerView: 1.3
              },
              768: {
                slidesPerView: 2
              },
              1024: {
                slidesPerView: 3
              },
            }}
            centeredSlides={false}
            loop={false}
            autoplay={{
              delay: 6000,
              disableOnInteraction: false
            }}
            slidesPerView={1.3}
            spaceBetween={5}
            navigation={true}
            modules={[Autoplay, Navigation]}
            onBeforeInit={(swiper) => {
              swiperRef.current = swiper;
            }}
          >
            {
              lastInvestments.map((investment: any, index: number) =>
                <SwiperSlide className="logo" key={index}>
                  <div className={`
                    px-4
                    flex
                    justify-center
                    ${index === (lastInvestments.length - 1) ? '' : 'border-r-2'}`}>
                    <div>
                      <p className="text-[#5452F6] primaryFont font-semibold capitalize">{investment.investorName}</p>
                      <p className="font-syne primaryFont">se unió {dateToRelativeFormat(investment.date)} a LOKL con <span className="primaryFont font-semibold">{numberToCurrencyFormat(investment.value)}</span></p>
                    </div>
                  </div>
                </SwiperSlide>
              )
            }
          </Swiper>
        {/*   <div className="hidden md:block">
            <button onClick={() => swiperRef.current?.slidePrev()} className="absolute top-[50%] left-0 translate-y-[-50%] rotate-180 z-30">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5007 22.9166C18.2538 22.9166 22.9173 18.253 22.9173 12.4999C22.9173 6.74679 18.2538 2.08325 12.5007 2.08325C6.74753 2.08325 2.08398 6.74679 2.08398 12.4999C2.08398 18.253 6.74753 22.9166 12.5007 22.9166Z" stroke="#656565" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.1875 16.1772L14.8542 12.5001L11.1875 8.823" stroke="#656565" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <button onClick={() => swiperRef.current?.slideNext()} className="absolute top-[50%] right-0 translate-y-[-50%] z-30">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5007 22.9166C18.2538 22.9166 22.9173 18.253 22.9173 12.4999C22.9173 6.74679 18.2538 2.08325 12.5007 2.08325C6.74753 2.08325 2.08398 6.74679 2.08398 12.4999C2.08398 18.253 6.74753 22.9166 12.5007 22.9166Z" stroke="#656565" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.1875 16.1772L14.8542 12.5001L11.1875 8.823" stroke="#656565" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div> */}
        </div>
        <div className="col-span-3 flex items-center justify-center">
          <Link id='btnGoToNidoPageCommunityGallery' to={'/project/nido-de-agua'} className="text-white bg-black rounded-full px-14 py-3  font-bold primaryFont leading-none no-underline">
            Quiero ser Parte
          </Link>
        </div>
        </div>
        <div className="mt-10">
          <CommunityGallery />
        </div>
        {/* <div className="my-4">
          FIXME: Add href of google form
          <a href="/" className="text-[#3533FF] font-epilogue font-medium text-lg">Ya haces parte de la comunidad? Cuéntanos sobre tu experiencia AQUÍ</a>
        </div> */}
        <div className="md:hidden mt-10 flex justify-center">
          <Link id='btnGoToNidoPageCommunityGalleryMobile' to={'/project/nido-de-agua'} className="text-white bg-black rounded-full px-14 py-3 primaryFont font-bold leading-none no-underline">
            Quiero ser Parte
          </Link>
      </div>
    </div>
  )
}
